  const singleSpacer = value => value.replace(/\s{2,}/g, ' ');

  export default singleSpacer;
